import * as THREE from "three";
import { GROUND_LENGTH, GROUND_WIDTH, TILE } from "./config";

const TILE_A = "#2f343c";
const TILE_B = "#3a414b";
const GROUT = 0x1a1f26;
const EDGE = 0x5ee0c8;

export function buildLot(): THREE.Group {
  const lot = new THREE.Group();
  lot.name = "lot";

  const slab = new THREE.Mesh(
    new THREE.BoxGeometry(GROUND_WIDTH + 0.4, 0.08, GROUND_LENGTH + 0.4),
    new THREE.MeshStandardMaterial({
      color: GROUT,
      roughness: 0.92,
      metalness: 0.04,
    }),
  );
  slab.position.y = -0.06;
  slab.receiveShadow = true;
  lot.add(slab);

  const tex = checkerTexture();
  tex.repeat.set(GROUND_WIDTH / (2 * TILE), GROUND_LENGTH / (2 * TILE));

  const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(GROUND_WIDTH, GROUND_LENGTH),
    new THREE.MeshStandardMaterial({
      map: tex,
      roughness: 0.82,
      metalness: 0.06,
    }),
  );
  floor.rotation.x = -Math.PI / 2;
  floor.position.y = 0;
  floor.receiveShadow = true;
  lot.add(floor);

  lot.add(buildGrid(GROUND_WIDTH, GROUND_LENGTH, 10 * TILE, 0x4a5560, 0.018, 0.4));

  const frame = new THREE.LineSegments(
    new THREE.EdgesGeometry(new THREE.BoxGeometry(GROUND_WIDTH, 0.02, GROUND_LENGTH)),
    new THREE.LineBasicMaterial({ color: EDGE, transparent: true, opacity: 0.45 }),
  );
  frame.position.y = 0.04;
  lot.add(frame);

  return lot;
}

function buildGrid(
  width: number,
  length: number,
  step: number,
  color: number,
  y: number,
  opacity: number,
): THREE.LineSegments {
  const pts: THREE.Vector3[] = [];
  const x0 = -width / 2;
  const x1 = width / 2;
  const z0 = -length / 2;
  const z1 = length / 2;
  for (let x = x0; x <= x1 + 1e-6; x += step) {
    pts.push(new THREE.Vector3(x, y, z0), new THREE.Vector3(x, y, z1));
  }
  for (let z = z0; z <= z1 + 1e-6; z += step) {
    pts.push(new THREE.Vector3(x0, y, z), new THREE.Vector3(x1, y, z));
  }
  return new THREE.LineSegments(
    new THREE.BufferGeometry().setFromPoints(pts),
    new THREE.LineBasicMaterial({ color, transparent: true, opacity }),
  );
}

function checkerTexture(): THREE.CanvasTexture {
  const c = document.createElement("canvas");
  c.width = 2;
  c.height = 2;
  const ctx = c.getContext("2d");
  if (!ctx) throw new Error("No 2d context");
  ctx.fillStyle = TILE_A;
  ctx.fillRect(0, 0, 2, 2);
  ctx.fillStyle = TILE_B;
  ctx.fillRect(1, 0, 1, 1);
  ctx.fillRect(0, 1, 1, 1);
  const tex = new THREE.CanvasTexture(c);
  tex.wrapS = THREE.RepeatWrapping;
  tex.wrapT = THREE.RepeatWrapping;
  tex.magFilter = THREE.NearestFilter;
  tex.minFilter = THREE.NearestFilter;
  tex.colorSpace = THREE.SRGBColorSpace;
  return tex;
}
